(function($) {
  $(document).ready(function() {
    /**
     * COLLAPSES
     *
     * Scroll to the top of the collapse when opening it.
     */

    // Add to all element with `.js-scroll-to`
    $('.js-scroll-to').on('shown.bs.collapse', function () {
      $('html,body').animate({
          scrollTop: $(this).offset().top - "80"
        }, 50
      );
    });
  });
})(jQuery);
